import EmployeesInfo from "./EmployeesInfo";

export default EmployeesInfo;